<template>
  <div class="purchase-summary">
    <h3 class="mb-0">{{ __('Resumo da compra') }}:</h3>

    <div class="summary">
      <strong class="plan-name">{{ __('Plano') }} {{ planName }}</strong>

      <p v-if="hasDiscount" class="from mb-0">{{ __('De') }} <span>{{ currencyFormat(value) }}</span></p>

      <p class="value mb-0">
        <strong>{{ currencyFormat(calculatedValue) }}</strong> <span>{{ __('mensal') }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { currencyFormat } from '../../helpers/currencyFormat';

export default {
  props: {
    planName: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    discount: {
      type: [Object, null],
      default: null,
    },
  },

  computed: {
    hasDiscount () {
      return this.discount && this.discount.value > 0;
    },

    calculatedValue () {
      if (!this.hasDiscount) {
        return this.value;
      }

      if (this.discount.type === 'amount') {
        return this.value - this.discount.value;
      }

      if (this.discount.type === 'percent') {
        return this.value - (this.value * (this.discount.value / 100));
      }

      return this.value;
    },
  },

  methods: {
    currencyFormat (value) {
      return currencyFormat(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.purchase-summary {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  h3 {
    @include salesflow-subtitle(
      $color: $salesflow-font-gray-light,
      $font-weight: 700,
      $line-height: 131.25%
    );
    font-family: 'Inter';
  }

  .summary {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .plan-name {
      color: $salesflow-font-dark;
      font-weight: 700;
      font-size: 1.5rem;
      font-family: 'Inter';
      line-height: 75%;
      overflow-wrap: break-word;
    }

    .from {
      color: $salesflow-info;
      font-family: 'Inter';
      font-size: 1rem;
      font-weight: 400;
      line-height: 112.5%;

      span {
        text-decoration: line-through;
      }
    }

    .value {
      color: $salesflow-secondary-hover;
      font-family: 'Inter';
      font-size: 2rem;
      font-weight: 700;
      line-height: 60%;

      span {
        font-size: 1rem;
        font-weight: 400;
        line-height: 120%;
      }
    }
  }

}

</style>
